import styled from 'styled-components';

export const MapIframe = styled.iframe`
  border: 0;
  margin-bottom: -7px;
`;
